export const SET_EVENT_LANGUAGES = 'SET_EVENT_LANGUAGES';


export const setEventLanguages = (languages) => {
    return {
        type: SET_EVENT_LANGUAGES,
        payload: languages
    }
}